import React, { useRef, useEffect } from 'react';
import './ChatView.css';
import Message from '../Message/Message';
import 'intersection-observer';
import TextInput from '../TextInput/TextInput';
import Spinner from '../Spinner/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { getUserId } from '../../store/User/UserSelectors';
import { sendMessageAction } from '../../store/Messages/MessagesActions';
import {
  getLimitReached,
  getMessages,
  isMessagesLoading,
} from '../../store/Messages/MessagesSelectors';
import { getTenantConfig } from '../../store/Config/configSelectors';

const ChatView = ({ setHome }) => {
  const dispatch = useDispatch();

  const messagesEndRef = useRef(null);
  const initialPromptSent = useRef(false);

  const userId = useSelector(getUserId);
  const messages = useSelector(getMessages);
  const isLoading = useSelector(isMessagesLoading);
  const limitReached = useSelector(getLimitReached);
  const { messageFlagEnabled, initialPrompt } = useSelector(getTenantConfig);

  const sendMessage = async message => {
    setHome(false);
    dispatch(sendMessageAction(message));
  };

  useEffect(() => {
    if (!initialPromptSent.current && initialPrompt && messages.length === 0) {
      sendMessage({ type: 'user', message: initialPrompt });
      initialPromptSent.current = true;
    }
  }, [initialPrompt]);

  return (
      <div className="Chat-Scroll-Wrapper">
        <div className="test-box">
          {messages?.map((message, index) => (
              <Message
                  key={index}
                  message={message}
                  user={userId}
                  messageFlagEnabled={messageFlagEnabled}
              />
          ))}
          <div ref={messagesEndRef} />
        </div>

        {isLoading && <Spinner />}

        {!limitReached && (
            <div className="convInput">
              <TextInput
                  placeholder="Ask a question..."
                  style={{ marginLeft: '20px' }}
                  disabled={isLoading}
                  onPress={message => {
                    sendMessage({ type: 'user', message });
                  }}
              />
            </div>
        )}

        <div className="poweredByEma">Powered by Ema v1.0.3</div>
      </div>
  );
};

export default ChatView;
